export default __webpack_public_path__ + "static/media/thienkhoc.5113a7ef.png";